import { Entry } from 'contentful'
import {
  IContentfulConfigurableCtaEntry,
  TContentfulConfigurableCta,
} from 'types/contentful/configurableCta.types'

export const parseConfigurableCta = (
  configurableCta: Entry<IContentfulConfigurableCtaEntry>
): TContentfulConfigurableCta => {
  const cta = {
    componentKey: 'configurableCta',
    ...configurableCta?.fields,
  }

  return cta
}
